// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__27hwW","clinicsSelect":"TableHeading_clinicsSelect__3LI4l"};